var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Add/Edit Cargo Damage")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$emit('prevPage')
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "MPS Number :",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentDetails.ShippingID),
      expression: "ShipmentDetails.ShippingID"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "awbnumber",
      "disabled": _vm.disableFields,
      "name": "awbnumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ShipmentDetails.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentDetails.ShippingID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "disabled": _vm.disableFields
    },
    on: {
      "click": function($event) {
        _vm.$emit('fetchDeails', 'ShipmentData.awbnumber')
      }
    }
  }, [_vm._v("Go "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v(" Current Region:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "origin_hub_name",
      "disabled": _vm.disableFields,
      "name": "origin_hub_name"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.ZoneName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.ZoneName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.ZoneName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Origin Hub/SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "current_hub_name",
      "disabled": _vm.disableFields,
      "name": "OriginHubName"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.originHubName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.originHubName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.originHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v(" Current Hub/SVC:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "current_hub_name",
      "disabled": _vm.disableFields,
      "name": "current_region_name"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.currentHubName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.currentHubName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.currentHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "name": "DamageType",
      "disabled": _vm.disableFields,
      "label": "Damage Type:<span style='color: red'>*</span> ",
      "label-cols": 2,
      "horizontal": true
    }
  }, [_c('div', [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.disableFields,
      "options": [{
          text: 'Minor',
          value: '1'
        },
        {
          text: 'Major',
          value: '2'
        }
      ],
      "value": _vm.ShipmentDetails.damagetype
    },
    on: {
      "change": function($event) {
        _vm.selectData($event)
      }
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Zone :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "DamageZone",
      "disabled": _vm.disableFields,
      "name": "DamageZone"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.DamageZoneName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.DamageZoneName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.DamageZoneName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Hub/SVC: :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "Damagehub",
      "disabled": _vm.disableFields,
      "name": "Damagehub"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.DamageHubName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.DamageHubName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.DamageHubName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Category: :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "DamageCategory",
      "disabled": _vm.disableFields,
      "name": "DamageCategory"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.damagecategoryName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.damagecategoryName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.damagecategoryName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Reason:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "Reason",
      "disabled": _vm.disableFields,
      "name": "Reason"
    },
    model: {
      value: (_vm.ShipmentDetails.Getallhubzone.ReasonName),
      callback: function($$v) {
        _vm.ShipmentDetails.Getallhubzone.ReasonName = $$v
      },
      expression: "ShipmentDetails.Getallhubzone.ReasonName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group-row"
  }, [_c('label', [_vm._v("Uploaded Pics:")]), _vm._v(" "), _c('div', {
    staticClass: "imageGroup"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "image-view-upload row"
    }, [_c('img', {
      staticClass: "col-md-offset-1 col-md-2 col-sm-3 col-xs-4",
      attrs: {
        "src": image.url
      },
      on: {
        "click": function($event) {
          _vm.showImage(image.url)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentDetails.loggeddescription),
      expression: "ShipmentDetails.loggeddescription"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disableFields,
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.ShipmentDetails.loggeddescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentDetails.loggeddescription = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showOctroiMRP) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Confirmed Claim Amount:",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-inr'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentDetails.netvalue),
      expression: "ShipmentDetails.netvalue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "OctroiMRP",
      "disabled": _vm.editOctroiMRP,
      "name": "OctroiMRP",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ShipmentDetails.netvalue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentDetails.netvalue = $event.target.value
      }
    }
  })])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('b-button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('updateDetails', _vm.ShipmentDetails)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), (_vm.ClikableBoxSave) ? _c('span', [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.ClikableBoxConfirm) ? _c('span', [_vm._v("Confirm")]) : _vm._e(), _vm._v(" "), (_vm.ClikableBoxProcess) ? _c('span', [_vm._v("Process")]) : _vm._e(), _vm._v(" "), (_vm.ClikableBoxApprove) ? _c('span', [_vm._v("Approve")]) : _vm._e(), _vm._v(" "), (_vm.ClikableBoxVerified) ? _c('span', [_vm._v("Verify")]) : _vm._e(), _vm._v(" "), (_vm.ClikableBoxRecevied) ? _c('span', [_vm._v("Recevied")]) : _vm._e()]), _vm._v(" "), (_vm.ClikableBoxCanceltoall) ? _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.$emit('prevPage')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), (_vm.ClikableBoxApprove) ? _c('b-button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.$emit('updateDetails', _vm.ShipmentDetails, _vm.isRejected)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v("Reject")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.img,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img,
      "alt": "loading..."
    }
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4598f304","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/B2B components/actionComponent.vue
// module id = 568
// module chunks = 1